<template>
  <div class="form-group">
    <label class="form-label text-muted" v-if="label">
      {{ label }} <i v-if="required" class="text-danger">*</i></label
    >
    <textarea
      style="resize: none"
      v-if="readOnly"
      :rows="rows"
      class="form-control form-disabled"
      :value="value"
      disabled
    />
    <textarea
      v-else
      class="form-control"
      v-model.trim="model.$model"
      :class="{ 'is-invalid': model.$error }"
      :type="type"
      :rows="rows"
      :placeholder="placeholder"
      :maxlength="maxLength"
    />
    <template v-if="showCharsLeft && !readOnly">
      <div class="text-end">
        <small class="text-muted" style="font-size: 0.7rem"
          >{{ maxLength - model?.$model?.length || maxLength }} caracteres
          restantes</small
        >
      </div>
    </template>
    <slot name="content"></slot>
    <div class="invalid-feedback">
      <small>{{ errorMsg }}</small>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    model?: any;
    type?: string;
    label?: string;
    placeholder?: string;
    errorMsg?: string;
    value?: string;
    readOnly?: boolean;
    rows?: number;
    maxLength?: number;
    required?: boolean;
    showCharsLeft?: boolean;
  }>(),
  {
    model: () => ({}),
    type: "text",
    label: "",
    placeholder: "",
    errorMsg: "Por favor, preencha este campo corretamente",
    value: "",
    readOnly: false,
    rows: 6,
    maxLength: 1000,
    required: false,
    showCharsLeft: true,
  },
);
</script>
